import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import HotRanking from "./components/HotRanking";
import LatestUpdates from "./components/LatestUpdates";

export default function Home() {
  return (
    <main>
      <HeroSection />
      <CategoryGrid />
      <HotRanking />
      <LatestUpdates />

      <section className="py-14 md:py-20 px-4 md:px-6 bg-background-900 text-background-50 text-center">
        <div className="max-w-[1400px] mx-auto max-w-2xl">
          <h2 className="text-2xl md:text-3xl font-bold font-heading mb-3">
            追剧不等待，精彩每一刻
          </h2>
          <p className="text-sm md:text-base text-background-300 mb-6 leading-relaxed">
            午马影院汇聚全网热播剧集，每日实时更新。高清流畅不缓冲，让您沉浸在精彩的剧情世界中。无论悬疑、古装、都市还是科幻，这里都有您想看的。
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-accent-500 font-display">
                1000+
              </div>
              <div className="text-xs md:text-sm text-background-400 mt-1">
                海量剧集
              </div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-accent-500 font-display">
                1080P
              </div>
              <div className="text-xs md:text-sm text-background-400 mt-1">
                高清画质
              </div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-accent-500 font-display">
                24h
              </div>
              <div className="text-xs md:text-sm text-background-400 mt-1">
                实时更新
              </div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-accent-500 font-display">
                99%
              </div>
              <div className="text-xs md:text-sm text-background-400 mt-1">
                用户好评
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}